import * as React from 'react';
import Img from 'gatsby-image/withIEPolyfill';
import * as s from './GatsbyBackgroundImage.module.scss';
import { Image } from '../../../types';

export enum Vertical {
  top = '0%',
  center = '50%',
  bottom = '100%',
}

export enum Horizontal {
  left = '25%',
  center = '50%',
  right = '75%',
}

interface Props {
  image: Image;
  children?: any;
  fadeIn?: boolean;
  className?: string;
  imagePositioning?: {
    vertical: Vertical;
    horizontal: Horizontal;
  };
  objectFit?: 'cover' | 'contain';
  imageClass?: string;
}

const BackgroundImage = ({
  image,
  children,
  fadeIn,
  className,
  imagePositioning,
  objectFit,
  imageClass,
}: Props) => {
  const wrapperClasses = [s.wrapper];
  if (className) {
    wrapperClasses.push(className);
  }

  const vert =
    (imagePositioning && Vertical[imagePositioning.vertical]) ||
    Vertical.center;
  const horiz =
    (imagePositioning && Horizontal[imagePositioning.horizontal]) ||
    Horizontal.center;

  const backgroundPos = {};
  if (!!imagePositioning) {
    (backgroundPos['backgroundPositionX'] = imagePositioning.horizontal),
      (backgroundPos['backgroundPositionY'] = imagePositioning.vertical);
  }

  const imageClasses = [s.image, imageClass];
  if (!objectFit || objectFit === 'cover') {
    imageClasses.push(s.bgCover);
  } else {
    imageClasses.push(s.bgContain);
  }

  return (
    <div className={wrapperClasses.join(' ')}>
      {image && image.localFile && image.localFile.childImageSharp && (
        <Img
          className={s.image}
          fluid={image.localFile.childImageSharp.fluid}
          fadeIn={fadeIn}
          objectFit={objectFit || 'cover'}
          objectPosition={`${horiz} ${vert}`}
        />
      )}
      {image &&
        !(image.localFile && image.localFile.childImageSharp) &&
        (image.source_url || image.url) && (
          <div
            className={imageClasses.join(' ')}
            style={{
              backgroundImage: `url(${
                image.source_url ? image.source_url : image.url
              })`,
              ...backgroundPos,
            }}
          />
        )}
      <div className={s.content}>{children}</div>
    </div>
  );
};

export default BackgroundImage;
